import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupSubstract: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBooleanGroupSubstract"><Path fillRule="evenodd" clipRule="evenodd" d="M10.5 2C9.11929 2 8 3.11929 8 4.5V8H4.5C3.11929 8 2 9.11929 2 10.5V19.5C2 20.8807 3.11929 22 4.5 22H13.5C14.8807 22 16 20.8807 16 19.5V16H19.5C20.8807 16 22 14.8807 22 13.5V4.5C22 3.11929 20.8807 2 19.5 2H10.5ZM19.5 15C20.3284 15 21 14.3284 21 13.5V4.5C21 3.67157 20.3284 3 19.5 3H10.5C9.67157 3 9 3.67157 9 4.5V13.5C9 14.3284 9.67157 15 10.5 15H19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupSubstract;
